import axios from "axios";
import { apiUrl } from "./api";

export const authMaster = btoa(
  `${process.env.REACT_APP_ONCHEF_CLIENT_ID}:${process.env.REACT_APP_ONCHEF_CLIENT_SECRET}`
);

const token = async () => {
  //console.log("token");
  let bearer: string = "";
  try {
    const config = {
      authorization: `Basic ${authMaster}`,
    };
    const api = axios.create({
      baseURL: apiUrl,
      headers: config,
    });
    const response = await api.post("/auth");
    //console.log(response);
    if (
      response === null ||
      response.data === null ||
      response.data.code !== 200
    ) {
      return "";
    }

    bearer = response.data.data.token;
    await sessionStorage.setItem("@menuchef/token", bearer);
    return bearer;
  } catch (error) {
    console.log(error);
    return "";
  } finally {
    return bearer;
  }
};

// Requisição de token em voo, compartilhada entre os chamadores: a
// StoreThemeProvider e a página da loja chamam auth() no mesmo mount, e sem
// isso o navegador dispararia dois POST /auth concorrentes.
let pendingToken: Promise<string> | null = null;

export const auth = async () => {
  //console.log("auth");
  try {
    let bearer = sessionStorage.getItem("@menuchef/token") || "";
    //console.log(bearer);
    if (bearer === undefined || bearer === "") {
      if (!pendingToken) {
        pendingToken = token().finally(() => {
          pendingToken = null;
        });
      }
      bearer = await pendingToken;
    } else {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      /*const { isExpired } = useJwt(bearer);
      console.log(`isExpired(${isExpired})`);
      if (isExpired) {
        bearer = await token();
      }*/
    }
    //console.log(bearer);
    return bearer;
  } catch (error) {
    console.log(error);
    return "";
  }
};
